import { Wifi, WifiOff } from 'lucide-react';
import { useEffect, useState, useSyncExternalStore } from 'react';
import { mouvementReduit, usePresence } from './sortie';

function abonner(rappel: () => void): () => void {
  window.addEventListener('online', rappel);
  window.addEventListener('offline', rappel);
  return () => {
    window.removeEventListener('online', rappel);
    window.removeEventListener('offline', rappel);
  };
}

/** Vrai tant que le navigateur se déclare en ligne. */
export function useEnLigne(): boolean {
  return useSyncExternalStore(
    abonner,
    () => navigator.onLine,
    () => true,
  );
}

/** Délai pendant lequel le bandeau reste affiché au retour du réseau, pour que le changement se lise. */
const MAINTIEN_RETOUR_MS = 1000;

/**
 * Bandeau de la SPEC 4 (règle 13) : seule la coquille de l'application reste disponible hors ligne.
 * Posé en surimpression sous l'en-tête (la mise en page ne bouge pas, le bouton de recherche reste libre).
 */
export function BandeauHorsLigne() {
  const enLigne = useEnLigne();
  const [visible, setVisible] = useState(!enLigne);

  useEffect(() => {
    if (!enLigne) {
      setVisible(true);
      return;
    }
    if (mouvementReduit()) {
      setVisible(false);
      return;
    }
    const minuteur = setTimeout(() => setVisible(false), MAINTIEN_RETOUR_MS);
    return () => clearTimeout(minuteur);
  }, [enLigne]);

  const { monte, propsSortie } = usePresence(visible || !enLigne);
  if (!monte) return null;
  return (
    <div
      role="status"
      {...propsSortie}
      className="apparition pointer-events-none fixed inset-x-0 top-14 z-40 flex justify-center px-3 [--decalage:-100%]"
    >
      <div
        className={`flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-center text-sm font-medium text-[var(--accent-texte)] shadow-lg ${enLigne ? 'bg-accent' : 'bg-alerte'}`}
      >
        {enLigne ? <Wifi size={16} aria-hidden /> : <WifiOff size={16} aria-hidden />}
        {enLigne ? 'De nouveau en ligne' : 'Hors ligne, les données ne sont pas disponibles'}
      </div>
    </div>
  );
}
